/* assets/js/modules/time-rail.js
   Syncs active mark on the left time-rail to the nearest heading in view. */

(function () {
    'use strict';
    const rail = document.querySelector('.d-time-rail');
    if (!rail) return;
    const marks = rail.querySelectorAll('.mark');
    const content = document.querySelector('.post-content');
    if (!content || !marks.length) return;

    const heads = [...content.querySelectorAll('h2, h3')].slice(0, marks.length);
    if (!heads.length) return;

    function update() {
        const y = window.scrollY + window.innerHeight * 0.25;
        let idx = 0;
        heads.forEach((h, i) => { if (h.offsetTop <= y) idx = i; });
        marks.forEach((m, i) => m.classList.toggle('active', i === idx));
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
})();
